import ApiService from '@services/api.service'
import storageService from '@services/storage.service'

const UserService = {
  async getUserInfoByUserName() {
    var employeeNumber = storageService.getEmployeeNumber()
    if (employeeNumber === null || employeeNumber === undefined) {
      const response = await ApiService.get('/Job/UserInfo').catch((err) => {
        throw err
      })
      employeeNumber = response.data
      storageService.saveEmployeeNumber(employeeNumber)
    }
    // Google Analytics/Tag Manager
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ employeeNumber: employeeNumber })
    // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
    return employeeNumber
  },
  ClearUserInfo() {
    storageService.removeEmployeeNumber()
  },
}

export default UserService
